export const statisticForms: TableModule = {
    name: "statisticForms",
    route: "spa.statistics.statisticForms",
    defaultOrder: {
        column: "sort",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "statisticSurvey",
            sortable: true,
            breakpoint: 'lg',
        }, {
            name: "type",
            sortable: true,
            breakpoint: 'md',
        }, {
            name: "identifier",
            breakpoint: 'md',
        }, {
            name: "is_active",
            width: "w-[75px]",
        }, {
            name: "sort",
            sortable: true,
            width: "w-[150px]"
        }
    ],
    filters: [
    ],
    quickFilters: [
    ],
    tools: [
        {
            name: "statisticForms.create",
            isCreateAction: true,
            ability: [
                "create",
                "statisticForms"
            ]
        }
    ]
}